import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { strings, SUPPORTED } from '../i18n/strings';

const LanguageContext = createContext(null);
const STORAGE_KEY = 'dgf_lang';

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === 'undefined') return 'pl';
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (saved && strings[saved]) return saved;
    const nav = window.navigator?.language?.slice(0, 2)?.toLowerCase();
    if (nav === 'pl') return 'pl';
    return 'en';
  });

  useEffect(() => {
    document.documentElement.lang = lang;
    window.localStorage.setItem(STORAGE_KEY, lang);
  }, [lang]);

  const setLang = useCallback((code) => {
    if (strings[code]) setLangState(code);
  }, []);

  const t = useMemo(() => strings[lang] || strings.pl, [lang]);

  const value = useMemo(() => ({ lang, setLang, t, supported: SUPPORTED }), [lang, setLang, t]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
}
